import {XCLaunchOptions} from '@gongxigames/framework/integrations/pokerstars/PSTypes';
import {CoreSettingsParameters, ISettings, SettingsParametersSchema} from '@gongxigames/framework/core';
import {GameClientWrapperSettingsParameters, SlotSettingsParameters} from '@gongxigames/framework/slot';
import {RubyPlayGameClientWrapperSettingsParameters} from '@gongxigames/framework/integrations/rubyplay/RubyPlayGameClientWrapperSettings';

type PSSettingsParameters = {
    xcLaunchGameOptions?: XCLaunchOptions;
    crossLaunchUrl: string;
    siteName: string;
};

export const PS_SETTINGS_PARAMETERS_SCHEMA: SettingsParametersSchema<PSSettingsParameters> = {
    crossLaunchUrl: {
        readonly: true,
        defaultValue: '',
        urlParser: {
            alias: 'cross_launch_url',
            typePropertyInURL: 'string'
        }
    },
    xcLaunchGameOptions: {
        readonly: true,
        defaultValue: undefined,
        urlParser: {
            typePropertyInURL: 'string',
            parseValue: value => JSON.parse(value)
        }
    },
    siteName: {
        readonly: true,
        defaultValue: '',
        urlParser: {
            typePropertyInURL: 'string'
        }
    }
};

export type PSSettings = ISettings<
    CoreSettingsParameters &
    SlotSettingsParameters &
    GameClientWrapperSettingsParameters &
    RubyPlayGameClientWrapperSettingsParameters &
    PSSettingsParameters
>;
